export function common(): string {
  return 'common';
}
